import { Pipe, PipeTransform } from '@angular/core';
import { Employee } from 'src/app/shared/models/employee/employee';
import { Expertise } from 'src/app/shared/models/expertise';

@Pipe({
	name: 'filterEmployeeByExpertises'
})
export class FilterEmployeeByExpertisesPipe implements PipeTransform {
	transform(employees: Employee[], expertises: Expertise[]): Employee[] {
		if (
			employees === null ||
			expertises === null ||
			expertises.length === 0
		) {
			return employees;
		}

		return employees.filter((employee) => {
			return employee.expertises.some((exp) =>
				expertises
					.map((exp) => exp.name)
					.some((expStr) => expStr.includes(exp.name))
			);
		});
	}
}
